import cx from 'classnames'

import {
  SanityFilterGroup,
  SanityFilterGroupDisplay,
} from '@data/sanity/queries/types/filter'
import { Filter } from '@lib/product'
import { UrlParameter } from '@lib/url'

import CollectionFilterOption from './filter-option'

interface CollectionFilterGroupProps {
  group: SanityFilterGroup
  onChange: (newParameters: UrlParameter[]) => void
  activeFilter?: Filter
}

const CollectionFilterGroup = ({
  group,
  activeFilter,
  onChange,
}: CollectionFilterGroupProps) => {
  const id = group._key
  const groupTotal = activeFilter?.values?.length ?? 0

  return (
    <div className="pt-5 pb-7 px-4 sm:px-8 border-b border-gray last:border-0">
      <span
        id={`filter-group-${id}`}
        className="font-semibold text-lg mb-1 inline-flex items-center"
      >
        {group.title}

        {groupTotal > 0 && (
          <span className="opacity-30 ml-2 text-sm">({groupTotal})</span>
        )}
      </span>
      <div
        role="group"
        aria-labelledby={`filter-group-${id}`}
        className={cx('flex flex-wrap gap-y-2 justify-items-start mt-2', {
          'grid grid-cols-3 gap-4':
            group.display === SanityFilterGroupDisplay.GRID,
        })}
      >
        {group.options.map((option, index) => (
          <CollectionFilterOption
            key={index}
            option={option}
            activeFilter={activeFilter}
            isGrid={group.display === SanityFilterGroupDisplay.GRID}
            onChange={onChange}
          />
        ))}
      </div>
    </div>
  )
}

export default CollectionFilterGroup
